


















































































































































import { Watch } from 'vue-property-decorator';
import RecurringPaymentsProductManagementMixin from '@/components/product/recurringPayments/recurringPaymentsProductManagement/RecurringPaymentsProductManagementMixin';
import Component from 'vue-class-component';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CheckBoxElement from '@/components/common/CheckBoxElement.vue';
import CompSelectBox, { CompSelectBoxOption } from '@/components/common/CompSelectBox.vue';
import CopyMallProduct from '@/views/product/productListPopup/CopyMallProduct.vue';
import { DEFAULT_STATE, options, SearchFormOptions } from './SearchFormAssistant';
import {
  ContractedPartner,
  GetMallsContractedPartnersByMallNoRequest,
  GetProductsRegularDeliveryRequest,
  Mall,
  SaleStatusTypeForSubscription,
  ALLorYorN
} from 'supporter';
import { Getter } from 'vuex-class';
import AutoSearchInput, { CandidateDataItem } from '@/components/common/input/AutoSearchInput.vue';
import {stringify} from 'qs';
import {PeriodType} from '@/types';


interface SearchedPartner {
  partnerNo: number;
  partnerName: string;
  label: string;
}

@Component({
  components: {
    CopyMallProduct,
    PeriodDateCalendar,
    CheckBoxElement,
    CompSelectBox,
    AutoSearchInput,
  }
})
export default class SearchForm extends RecurringPaymentsProductManagementMixin {

  @Getter('mall/malls')
  private readonly malls!: Mall[];
  private options: SearchFormOptions = options();
  private mallSelectDisabled = false;
  private mallNo: number = 0;
  private searchKeywordType = 'PRODUCT_NAME';
  private searchKeywordValue = '';
  private startYmdt = '';
  private endYmdt = '';
  private saleStatus = 'ALL';
  private deliveryCycleStatus = 'ALL';
  private productStatus = 'ALL';
  private displayStatus = 'ALL';
  private partnerCandidateDataList: CandidateDataItem[] = [];
  private partnerNo = 0;

  private get mallOptions(): CompSelectBoxOption<number>[] {
    return this.malls.map(mall => ({
      name: mall.mallName, value: mall.mallNo
    }));
  }

  private get searchKeywordsList(): string[] | null {
    if (this.searchKeywordValue === '') {
      return null;
    }
    return this.searchKeywordValue.split(/[,\n]/).filter(Boolean).map(keyword => keyword.trim());
  }

  private mounted() {
    this.resetDate()
  }

  private resetDate() {
    const dateCalendar = this.$refs.dateCalendar as PeriodDateCalendar;
    const dateCalendarInputData = dateCalendar.getPeriod(this.options.periodOption.period as PeriodType);

    this.startYmdt = dateCalendarInputData.start;
    this.endYmdt = dateCalendarInputData.end;
  }

  @Watch('mallNo')
  private handleMallNoChange(): void {
    if (this.mallNo === 0) {
      this.partnerCandidateDataList = [];
      return;
    }
    this.fetchPartnerCandidateDataList();
  }

  private fetchPartnerCandidateDataList(): void {
    const request: GetMallsContractedPartnersByMallNoRequest = {
      pathParams: {
        mallNo: this.mallNo.toString(),
      },
    }

    try {
      this.$api.getMallsContractedPartnersByMallNo(request).then( ({data}) => {
        const filteredPartners = data.filter(item => {
          return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
        });
        this.partnerCandidateDataList = this.makePartnerCandidateDataList(filteredPartners);
      })
    } catch (e) {
      console.log(e);
    }
  }

  private makePartnerCandidateDataList(responseData: ContractedPartner[]): CandidateDataItem[] {
    return responseData.map((partnerData: ContractedPartner) => ({
      name: partnerData.partnerName,
      value: partnerData.partnerNo,
    }))
  }

  private handleSearchClick(): void {
    const isDeliveryCycleStatusAll = this.deliveryCycleStatus === 'ALL';
    const saleStatusAll = ['READY','RESERVATION_ONSALE','ONSALE','FINISHED','STOP','PROHIBITION'];

    const queryObject: GetProductsRegularDeliveryRequest['params'] = {
      keywordInfo: {
        type: this.searchKeywordType,
        keywords: this.searchKeywordsList,
      },
      mallNos: this.mallNo ? [Number(this.mallNo)] : null,
      partnerNo: this.partnerNo ? this.partnerNo : null,
      registerPeriod: {
        startYmdt: this.startYmdt,
        endYmdt: this.endYmdt,
      },
      saleStatusTypes: this.saleStatus === 'ALL' ? saleStatusAll as SaleStatusTypeForSubscription[] : this.saleStatus.split(',') as SaleStatusTypeForSubscription[],
      deliveryCycleInfo: {
        isAll: isDeliveryCycleStatusAll,
        deliveryCycles: isDeliveryCycleStatusAll ? [] : this.deliveryCycleStatus.split(','),
      },
      applyStatusType: this.productStatus as 'REGISTRATION_READY',
      allowsFrontDisplay: this.displayStatus as ALLorYorN,
      hasTotalCount: true,
    }

    const sendQueryString = (vueComponent, queryObject: Record<string, any>): void => {
      queryObject['dataRefresh'] = (new Date()).toString(); // 동일 queryObject로 요청해도 갱신될 수 있도록 (duplicate 에러 방지)
      vueComponent.$router.replace(vueComponent.$route.path +
          '?' + stringify(queryObject, {
            arrayFormat: 'comma',
            allowDots: true,
            skipNulls: true,
          })
      )
    }

    sendQueryString(this, queryObject);
  }

  private handleResetClick(): void {
    Object.entries(DEFAULT_STATE).forEach( ([key, value]) => {
      this[key] = value;
    })
    this.resetDate();
  }
}

